import React from "react";
import styled from "styled-components";
import { Post } from "@domain/post/post";
import { gap } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { UserView } from "@ui/components/profile/userView";
import { PostContent } from "./postContent";

interface ReadonlyPostProps extends React.HTMLAttributes<HTMLDivElement> {
	post: Post;
}
export const ReadonlyPost: React.FC<ReadonlyPostProps> = ({ post, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<UserView user={post.author} showDescription alignStart pictureSize={"M"} />
			<PostContent post={post} readonly />
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 20px;
	pointer-events: none;
	${gap(20)}
`;
